import isFunction from 'lodash/isFunction';
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import filter from 'lodash/filter';
import flattenDeep from 'lodash/flattenDeep';

import './barsSelector.scss';

const PREDEF_SETUP = 'glazingBar';
const HIDE_MULLION_RULE_LINE_ID = 101;

class barsSelectorCtrl {
    constructor(
        dataService,
        sashesService,
        windowDimensionsService,
        imagesService,
        cartBarsService,
        dividersService,
        addMullionService,
        notificationService,
        $scope,
        $translate,
        $rootScope
    ) {
        this.dataService = dataService;
        this.sashesService = sashesService;
        this.imagesService = imagesService;
        this.windowDimensionsService = windowDimensionsService;
        this.cartBarsService = cartBarsService;
        this.dividersService = dividersService;
        this.addMullionService = addMullionService;
        this.notificationService = notificationService;
        this.mullionsSetups = cartBarsService.getMullionsSetups();
        this.mullionSetup = sashesService.setup;
        this.mullions = [];
        this.productHasDecorMullions = false;
        this.barsType = (this.hideOnMullionRule()) ? 'muntins' : 'mullions';
        this.configurationsType = 'defaultConfigurations';
        this.predefinedSetupsDescriptionHide = true;
        this.lineMullionsDescription = this.dataService.data.productInfo.lineMullionsDescription;
        this.lineMuntinsDescription = this.dataService.data.productInfo.lineMuntinsDescription;
        this.canHavePredefinedSetups = this.dataService.data.productInfo.canHavePredefinedSetups;

        if (!this.canHavePredefinedSetups) {
            this.configurationsType = 'designYourself';
        }

        if (this.mullionsSetups.length > 0) {
            $translate('EMPTY').then((translation) => {
                const oldSetupId = this.dataService.data.data[0].attributes.mullionSetup;
                const epmty = {
                    id: -1,
                    display: translation,
                };

                this.mullionsSetups.unshift(epmty);

                if (oldSetupId) {
                    this.mullionSetup = find(this.mullionsSetups, (el) => el.id == oldSetupId); // eslint-disable-line
                } else {
                    this.mullionSetup = epmty;
                }
            });
        }

        this.addMullionService.dividerSize = [];
        this.addMullionService.mullionSize = [];
        this.mullionColor = [];
        this.color = [];
        this.sashes = this.sashesService.getSashesJson();
        this.$scope = $scope;
        this.$rootScope = $rootScope;

        forEach(['mullionSize', 'dividerSize', 'color'], (el) => {
            forEach(dataService.getAttributeOptions(el), (el1) => {
                const option = el1;
                option.attributes.id = el1.id;
                if (el == 'color') {
                    this[`${el}`].push(el1.attributes);
                } else {
                    this.addMullionService[`${el}`].push(el1.attributes);
                }
            });
        });
        const mullionPalette = dataService.getAttributeOptions('mullionPalettes');
        forEach(mullionPalette, (el) => {
            const color = filter(this.color, el1 => el1.paletteId === el.id);
            this.mullionColor = flattenDeep([this.mullionColor, color]);
        });
        // this.color = filter(this.color, el => el.paletteId === mullionPalette.id);

        this.addMullionService.selectedDividerSize = find(this.addMullionService.dividerSize, ['id', this.dataService.getSelectedOptionId('dividerSize')]);
        this.glazingBars = [];
        this.insideMuntinsColors = [];
        this.outsideMuntinsColors = [];
        this.muntinTypes = [{
                'type': 'middleglass',
                'available': true,
            },
            {
                'type': 'external',
                'available': true,
            },
            {
                'type': 'in_out_duplex',
                'available': this.dataService.isDuplexMullionAvailable,
            },
        ];
        this.allMuntins = this.dataService.getAttributeOptions('mullionSize');
        this.muntinsPalettes = this.dataService.getMuntinsColorPaletts();
        this.isMullionTypeRestrictionNotificationVisible = false;

        $translate('DIAGONAL_SETUP_RULE_NOTIFICATION').then((phrase) => {
            this.mullionTypeRestrictionNotification = phrase;
        });
    }

    isMuntinTypeAvailable(type) {
        const muntinType = this.muntinTypes.find(muntinType => muntinType.type === type && muntinType.available);

        if (angular.isUndefined(muntinType)) {
            return false;
        }
        return true;
    }

    isMuntinTypeSelected(type) {
        return this.barsType === 'muntins' &&
            this.selectedMuntinType === type;
    }

    isPredefinedSetupAllowed(predefinedSetup) {
        // Predefined setups that contains diagonal muntins
        // are available only for constructions that has middleglass muntins enabled
        if (
            predefinedSetup.attributes.hasDiagonalMuntins &&
            this.filterMuntinsByType('middleglass').length === 0
        ) {
            return false;
        }
        return true;
    }

    // IMPORTANT!!!
    // during development try to refactor names
    // we should use names like:
    // mullions (divide shash into parts)
    // and muntins (don't divide sash, now across the project its called as bars, mullions, glazingbars so its a messy)

    $onInit() {
        this.moreInfo = this.dataService.getMoreInfo('glazingBar');
        this.mullionMoreInfo = this.dataService.getMoreInfo('mullion');
        this.addMullionService.selectedGrill = this.dataService.getSelectedOptionId(PREDEF_SETUP);
        this.mullions = this.dataService.getAttributeOptions('dividerSize');
        this.productHasDecorMullions = this.checkIfProductHasDecorMullions();

        this.addMullionService.selectedMullionSize = this.dataService.getSelectedOption('mullionSize', 'mullionSize');
        this.selectedMuntinType = this.getMuntinTypeBySelectedMuntin(this.addMullionService.selectedMullionSize);
        this.muntins = this.filterMuntinsByType(this.selectedMuntinType);
        this.insideMuntinsColors = this.muntinsPalettes[this.addMullionService.selectedMullionSize.attributes.insideColourPaletteId];
        this.outsideMuntinsColors = this.muntinsPalettes[this.addMullionService.selectedMullionSize.attributes.outsideColourPaletteId];
        this.selectedOutsideMuntinColor = this.outsideMuntinsColors.find(color => color.id == this.dataService.getSelectedOptionId('mullionColorOuter'));
        this.selectedInsideMuntinColor = this.insideMuntinsColors.find(color => color.id == this.dataService.getSelectedOptionId('mullionColorInner'));
    }

    filterMuntinsByType(selectedMuntinType) {
        const bars = [];
        this.allMuntins.forEach((bar) => {
            if (bar.attributes.barType === selectedMuntinType) {
                bars.push(bar);
            }
        });

        return bars;
    }

    changeMuntinType(selectedMuntinType) {
        this.muntins = this.filterMuntinsByType(selectedMuntinType);
        var defaultMuntinSize = this.muntins.find(muntin => muntin.attributes.isDefault);

        if (angular.isUndefined(defaultMuntinSize)) {
            defaultMuntinSize = this.muntins[0];
        }
        this.addMullionService.selectedMullionSize = defaultMuntinSize;
        this.changeMuntinSize(defaultMuntinSize, false);
    }

    getMuntinTypeBySelectedMuntin(selectedBar) {
        return selectedBar.attributes.barType;
    }

    setMuntinInsideColor(recalculatePrice = false) {
        this.dataService.updateSelectedOptions('mullionColorInner', [this.selectedInsideMuntinColor.id], 'mullionColorInner', false);
        if (recalculatePrice && this.sashesService.hasMuntins()) {
            this.$rootScope.$emit('colorChangeEvent');
        }
    }

    setMuntinOutsideColor(recalculatePrice = false) {
        this.dataService.updateSelectedOptions('mullionColorOuter', [this.selectedOutsideMuntinColor.id], 'mullionColorOuter', false);
        if (recalculatePrice && this.sashesService.hasMuntins()) {
            this.$rootScope.$emit('colorChangeEvent');
        }
    }

    addDivider(direction) {
        if (direction === 'horizontal') {
            this.dataService.userAddedDivider = true;
        }
        this.addMullionService.addDivider(direction);
        this.enableAllMuntinTypes();
    }

    changeMuntinSize(muntin, calculatePrice = true) {
        this.dataService.updateSelectedOptions('mullionSize', muntin.id, 'mullionSize', false);
        this.insideMuntinsColors = this.muntinsPalettes[this.addMullionService.selectedMullionSize.attributes.insideColourPaletteId];
        this.outsideMuntinsColors = this.muntinsPalettes[this.addMullionService.selectedMullionSize.attributes.outsideColourPaletteId];
        this.sashesService.updateSashesDimensions();

        const constructionColor = this.dataService.getSelectedOption('outer', 'color');

        let defaultInsideColor = this.insideMuntinsColors.find(color => color.id === constructionColor.id);
        let defaultOutsideColor = this.outsideMuntinsColors.find(color => color.id === constructionColor.id);

        defaultInsideColor = (!defaultInsideColor) ? this.insideMuntinsColors.find(color => color.matched_colour_id === constructionColor.id) : defaultInsideColor;
        defaultOutsideColor = (!defaultOutsideColor) ? this.outsideMuntinsColors.find(color => color.matched_colour_id === constructionColor.id) : defaultOutsideColor;

        defaultInsideColor = (!defaultInsideColor) ? this.insideMuntinsColors.find(color => color.id === this.addMullionService.selectedMullionSize.attributes.insideWhiteColorId) : defaultInsideColor;
        defaultOutsideColor = (!defaultOutsideColor) ? this.outsideMuntinsColors.find(color => color.id === this.addMullionService.selectedMullionSize.attributes.outsideWhiteColorId) : defaultOutsideColor;

        this.selectedOutsideMuntinColor = defaultOutsideColor;
        this.selectedInsideMuntinColor = defaultInsideColor;
        this.setMuntinInsideColor(false);
        this.setMuntinOutsideColor(true);

        if (calculatePrice && this.sashesService.hasMuntins()) {
            this.$rootScope.$emit('colorChangeEvent');
        }

        this.addMullionService.selectedMullionSize = muntin;
    }

    changeMullionSize(mullion) {
        this.dataService.updateSelectedOptions('dividerSize', mullion.id, 'dividersSize', true);
        this.addMullionService.selectedDividerSize = mullion;
    }

    checkIfConstructionRequiresMullions() {
        return this.addMullionService.requireMullions();
    }

    checkIfProductHasDecorMullions() {
        let decorMullionFound = false;
        for (let i = 0; i < this.mullions.length; i++) {
            if (this.mullions[i].attributes.type === 'decor') {
                decorMullionFound = true;
                break;
            }
        }
        return decorMullionFound;
    }

    addMullion(direction) {
        this.addMullionService.addMullion(direction);
        this.enableAllMuntinTypes();
    }

    getSpecialGrills() {
        if (this.windowDimensionsService.customWindow ||
            this.windowDimensionsService.topLightFields > 0) {
            return [];
        }
        let predefinedSetups = this.dataService.getAttributeOptions(PREDEF_SETUP);
        const sashWidth = this.windowDimensionsService.getSashWidth();

        if (this.addMullionService.systemAddedDividers.horizontal > 0) {
            return filter(predefinedSetups, (element) => Number(element.data.horizontalDividers) > 0);
        }
        if (sashWidth < 300) {
            return [predefinedSetups[2]];
        }

        if (this.hideOnMullionRule()) {
            return predefinedSetups.filter(setup => setup.data.horizontalDividers === 0 && setup.data.verticalDividers === 0);
        }

        return predefinedSetups;
    }

    openModal(moreInfo) {
        if (isFunction(this.openModalCallback)) {
            this.openModalCallback({
                modalTitle: moreInfo.attributes.name,
                modalContent: moreInfo.attributes.content,
            });
        }
    }

    openPreviewImageModal(image) {
        this.openModalCallback({
            modalFullImgSrc: image
        });
    }

    removeDivider(direction) {
        let performed = false;

        if (direction === 'vertical') {
            if (this.addMullionService.systemAddedDividers[direction] < this.sashesService.dividersVert) {
                this.sashesService.dividersVert--;
                performed = true;
            }
        } else {
            if (this.addMullionService.systemAddedDividers[direction] < this.sashesService.dividersHor) {
                this.sashesService.dividersHor--;
                performed = true;

                if (direction === 'horizontal' && (this.sashesService.dividersHor === 0 || this.sashesService.dividersHor === this.addMullionService.systemAddedDividers.horizontal)) {
                    this.dataService.userAddedDivider = false;
                }
            }
        }
        if (performed) {
            this.enableAllMuntinTypes();
            this.updateDividers();
        }
    }

    removeMullion(direction) {
        if (direction === 'vertical') {
            this.sashesService.mullionsVert--;
        } else {
            this.sashesService.mullionsHor--;
        }
        this.enableAllMuntinTypes();
        this.updateDividers();
    }

    onSetupChange() {
        this.resetGlazingBars();
        this.resetGrill();

        if (this.mullionSetup.id !== -1) {
            const attributes = this.mullionSetup.configuration.attributes;

            this.sashesService.dividersVert = attributes.dividersVertical;
            this.sashesService.dividersHor = attributes.dividersHorizontal;
            this.sashesService.mullionsHor = attributes.muntinsHorizontal;
            this.sashesService.mullionsVert = attributes.muntinsVertical;

            for (let i = 0; i < this.sashesService.dividersVert; ++i) {
                this.sashesService.addSashDivider('vertical');
            }
            for (let i = 0; i < this.sashesService.dividersHor; ++i) {
                this.sashesService.addSashDivider('horizontal');
            }
            this.updateMullions();

            this.sashesService.setMullionSetup(this.mullionSetup);
            this.dataService.data.data[0].attributes.mullionSetup = this.mullionSetup.id;
        } else {
            this.dataService.data.data[0].attributes.mullionSetup = null;
        }


        this.$rootScope.$emit('colorChangeEvent');
    }

    reset() {
        this.resetGrill();
        this.sashesService.clearWindowOptions();
        this.dividersService.resetDividers();
        this.$rootScope.$emit('colorChangeEvent');
    }

    toggleGrill(grill) {
        this.addMullionService.setMullionSetup(grill, false);

        if (grill.attributes.hasDiagonalMuntins) {
            this.showMullionTypeRestrictionNotification();
            this.enableSingleMuntinType('middleglass');
            this.setBarType('muntins-middleglass');
        } else {
            this.enableAllMuntinTypes();
        }
        this.$rootScope.$emit('colorChangeEvent');
    }

    showMullionTypeRestrictionNotification() {
        this.isMullionTypeRestrictionNotificationVisible = true;
        this.notificationService.displayNotificationInConfigurator(this.mullionTypeRestrictionNotification);
    }

    hideMullionTypeRestrictionNotification() {
        this.isMullionTypeRestrictionNotificationVisible = false;
        this.notificationService.removeLatestNotification();
    }

    enableAllMuntinTypes() {
        this.hideMullionTypeRestrictionNotification();
        this.muntinTypes.forEach((muntinType) => {
            muntinType.available = true;
        });
    }

    enableSingleMuntinType(muntinTypeToEnable) {
        this.muntinTypes.forEach((muntinType) => {
            muntinType.available = muntinType.type === muntinTypeToEnable ? true : false;
        });
    }

    resetGlazingBars() {
        this.sashesService.dividersVert = 0;
        this.sashesService.dividersHor = 0;
        this.sashesService.mullionsHor = 0;
        this.sashesService.mullionsVert = 0;
        this.updateDividers();
    }

    resetGrill() {
        this.addMullionService.resetGrill();
        this.hideMullionTypeRestrictionNotification();
        this.enableAllMuntinTypes();
    }

    resetBottomPanel() {
        this.addMullionService.resetBottomPanel();
    }

    setBottomPannel() {
        this.addMullionService.setBottomPannel();
    }

    updateDividers(refreshPrice = true) {
        this.addMullionService.updateDividers(refreshPrice);
    }

    updateMullions() {
        this.addMullionService.updateMullions();
    }

    getImageUrl(imgSrc) {
        return `/files/predefinedsetups/${this.imagesService.getFullUrl(imgSrc)}`;
    }

    closeBox() {
        if (isFunction(this.closeBoxCallback)) {
            this.closeBoxCallback();
        }
        // this.sashesService.updateSashesDimensions();
    }

    setBarType(type) {
        switch (type) {
            case 'mullions':
                if (this.hideOnMullionRule()) {
                    break;
                }
                this.barsType = 'mullions';
                break;

            case 'muntins-middleglass':
                if (!this.isMuntinTypeAvailable('middleglass')) {
                    return false;
                }
                if (this.selectedMuntinType !== 'middleglass') {
                    this.changeMuntinType('middleglass');
                }
                this.barsType = 'muntins';
                this.selectedMuntinType = 'middleglass';
                break;

            case 'muntins-external':
                if (!this.isMuntinTypeAvailable('external')) {
                    return false;
                }
                if (this.selectedMuntinType !== 'external') {
                    this.changeMuntinType('external');
                }
                this.barsType = 'muntins';
                this.selectedMuntinType = 'external';
                break;

            case 'muntins-in_out_duplex':
                if (!this.isMuntinTypeAvailable('in_out_duplex')) {
                    return false;
                }
                if (this.selectedMuntinType !== 'in_out_duplex') {
                    this.changeMuntinType('in_out_duplex');
                }
                this.barsType = 'muntins';
                this.selectedMuntinType = 'in_out_duplex';
                break;
        }
    }

    setConfigurationType(type) {
        switch (type) {
            case 'defaultConfigurations':
                this.configurationsType = 'defaultConfigurations';
                break;

            case 'designYourself':
                this.configurationsType = 'designYourself';
                break;
        }
    }

    setMuntinDescription() {
        let id = this.addMullionService.selectedMullionSize.id;
        let muntinSize = this.dataService.getAttributeOptions('mullionSize').find(obj => {
            return obj.id === id
        });
        return muntinSize.attributes.description;
    }

    setMullionDescription() {
        if (this.addMullionService.selectedMullionSize) {
            let id = this.addMullionService.selectedDividerSize.id;
            let mullionSize = this.dataService.getAttributeOptions('dividerSize').find(obj => {
                return obj.id === id
            });
            return mullionSize.attributes.description;
        }

        return '';
    }

    getMuntinImageUrl(imgSrc) {
        return `/files/mullionsizes/${imgSrc}`;
    }

    hideOnMullionRule() {
        return this.dataService.data.data[0].relationships.line.data.id === HIDE_MULLION_RULE_LINE_ID;
    }
}

barsSelectorCtrl.$inject = [
    'dataService',
    'sashesService',
    'windowDimensionsService',
    'imagesService',
    'cartBarsService',
    'dividersService',
    'addMullionService',
    'notificationService',
    '$scope',
    '$translate',
    '$rootScope',
];

export default barsSelectorCtrl;